__turbopack_context__.v({
  "clickable": "TagAantal-module-scss-module__3g4T6a__clickable",
  "tagRond": "TagAantal-module-scss-module__3g4T6a__tagRond",
});
